export const formatCardNumber = (cardNumber: string | null) => {
  if (cardNumber === null) return 0;
    return cardNumber
      .replace(/\s/g, "")
      .replace(/(.{4})/g, "$1 ")
      .trim();
  };